import banners from './modules/banners';
import announcements from './modules/announcements';
import merchants from './modules/merchants';
import courses from './modules/courses';
import categories from './modules/categories';
import sections from './modules/sections';

const storageName = 'previousPage';
const initialState = {
  dataServer: {},
  previousPage: null,
  isAppLoading: false,
  isLoading: {
    highlightedMerchant: false,
    merchants: false,
    merchantDetail: false,
    courses: false,
    courseDetail: false,
    categories: false,
    categoriesConfig: false,
    filterConfig: false,
  },
  isError: {
    highlightedMerchant: false,
    merchants: false,
    merchantDetail: false,
    courses: false,
    categories: false,
    categoriesConfig: false,
    filterConfig: false,
  },
  snackbar: {
    isShown: false,
    isError: false,
    message: '',
  },
};

const getters = {
  isAppLoading: (state) => state.isAppLoading || Object.values(state.isLoading).some((isLoading) => isLoading),
  isLoadingCourses: (state) => state.isLoading.courses,
  getPreviousPage: (state) => state.previousPage || JSON.parse(sessionStorage.getItem(storageName)),
  getError: (state) => state.isError,
  getSnackbar: (state) => state.snackbar,
};

const actions = {
  onSnackbarShow({commit}, {message = '', error = ''} = {}) {
    const payload = {
      isShown: true,
      isError: !!error,
      message: message || error,
    };
    commit('onSnackbarShow', payload);
  },
};
const mutations = {
  setDataServer(state, dataFromServer) {
    state.dataServer = dataFromServer;
  },
  setPreviousPage(state, previousPage) {
    if (previousPage?.name) {
      state.previousPage = previousPage;
      sessionStorage.setItem(
        storageName,
        JSON.stringify(
          Object.fromEntries(Object.entries(previousPage).filter(([key]) => ['path', 'name', 'params', 'query'].includes(key)))
        )
      );
    }
  },
  setLoading(state, loading) {
    state.isLoading = {...state.isLoading, ...loading};
  },
  setError(state, error) {
    state.isError = {...state.isError, ...error};
  },
  onSnackbarShow(state, payload) {
    state.snackbar = payload;
  },
  setAppLoading(state, isLoading) {
    state.isAppLoading = isLoading;
  },
  resetErrors(state) {
    state.isError = {
      highlightedMerchant: false,
      merchants: false,
      merchantDetail: false,
      courses: false,
      categories: false,
      categoriesConfig: false,
      filterConfig: false,
    };
  },
};

export default {
  state: {...initialState},
  getters,
  actions,
  mutations,
  modules: {
    banners,
    announcements,
    merchants,
    courses,
    categories,
    sections,
  },
};
